import React, { useState } from 'react';
import './style.css';

export const MobileMenu = ({
  menuItems = [],
  userEmail,
  shopName,
  onClose
}) => {
  return (
    <div className={"mobile-menu-overlay show"}>
      <div className="mobile-menu-content">
        <div className="mobile-menu-header">
          <span className="mobile-menu-title">{shopName}</span>
          <button className="mobile-menu-close" aria-label="Close menu" onClick={onClose}>
            <i className="pi pi-times"></i>
          </button>
        </div>
        <div className="mobile-menu-user">{userEmail}</div>
        <div className="mobile-menu-items">
          {menuItems.map((item, index) => (
            <div
              key={item.key || index}
              className={`mobile-menu-item${item.key === 'logout' ? ' logout' : ''}`}
              onClick={() => {
                item.command();
                onClose();
              }}
            >
              <i className={item.icon}></i>
              <span>{item.label}{item.new && <span className="menu-new-badge"> - New</span>}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
